import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class TeamService {
  constructor() {
    this.endpoints = createPrefix('/team', {
      teams: '/teams',
      team: (id) => `/team/${id}`,
    })
  }

  static create() {
    return new TeamService()
  }

  async get(id) {
    const servicePath = this.endpoints.team(id)
    const { data } = await axios.get(servicePath)
    return data
  }

  async query(params) {
    const servicePath = this.endpoints.teams()
    const { data } = await axios.get(servicePath, { params })
    return data
  }
}
